<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div class="background text app-content-container">
  @if (!hideTopbar) {
  <app-topbar [title]="topbarText" [topbarView]="TopbarView.BLUEPRINT_HOME" [imageFilePath]="topbarImage"
    (urlNavigate)="topBarNavigate($event)"></app-topbar>
  }

  @if (apiIsSick) {
  <div autosize>
    <h1>{{ apiMessage }}</h1>
    <h2>Please refresh this page.</h2>
    <h2>If the problem persists, please contact the site administrator.</h2>
  </div>
  }

  @if (!apiIsSick && !selectedMselId) {

  <section>
    <div class="top-row">
      <div class="one-cell last-cell">
        @if (canAccessAdminSection) {
        <button mat-icon-button style="outline: none;" (click)="topBarNavigate('/admin')" title="Administration">
          <mat-icon class="mdi-24px center-self" fontIcon="mdi-cog"></mat-icon>
        </button>
        }
      </div>
    </div>
    <div>
      <app-msel-list [loggedInUserId]="loggedInUserId" [canAccessAdminSection]="canAccessAdminSection"></app-msel-list>
    </div>
  </section>
  }

  @if (!apiIsSick && selectedMselId) {
  <div class="content-under-topbar">
    <app-msel [loggedInUserId]="loggedInUserId" [canEditMsel]="canEditMsels"
      [canAccessAdminSection]="canAccessAdminSection" [userTheme$]="theme$"
      (deleteThisMsel)="deleteMsel($event)"></app-msel>
  </div>
  }

  @if (isLoading$ | async) {
  <div>
    <mat-progress-bar color="primary" mode="indeterminate" style="width: 90%; margin: 20px;"></mat-progress-bar>
  </div>
  }
</div>
